import { useState, useEffect } from "react";
import { X } from "lucide-react";
import { getNewsListNo } from "context/actions/news";

export default function NoNumberPackagePopup({ open, onClose }) {
  const [searchValue, setSearchValue] = useState("");
  const [data, setData] = useState([]);
  const [check, setCheck] = useState(0);

  if (!open) return null;

  // Fetch function
  const getInitData = async () => {
    try {
      const res = await getNewsListNo(searchValue, 1);
      if (res.status === "success") {
        setData(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Handle search button click
  const handleSearch = () => {
    if (!searchValue.trim()) return;
    getInitData();
    setCheck(1);
  };

  return (
    <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-xl w-[90%] max-w-md p-6 shadow-xl relative animate-fade-up">
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          onClick={onClose}
        >
          <X size={22} />
        </button>

        <h2 className="text-xl font-bold text-gray-800 mb-4">
          Дугааргүй ачаа шалгах
        </h2>

        <p className="text-sm text-gray-600 mb-4">
          Та ачааны трак кодоо оруулж шалгана уу.
        </p>

        <input
          type="text"
          placeholder="Трак код"
          className="w-full border rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-primary"
          value={searchValue}
          onChange={(e) => setSearchValue(e.target.value)}
        />

        <button
          onClick={handleSearch}
          className="mt-4 w-full bg-primary text-white py-2 rounded-lg font-semibold hover:bg-primary/90"
        >
          Шалгах
        </button>

        {/* Example: Show results */}
        {check === 1 && data.length > 0 && (
          <div className="mt-4 space-y-4">
            {data.map((item, index) => (
              <div
                key={index}
                className="p-4 rounded-lg shadow-sm border border-border bg-white transition hover:shadow-md"
              >
                <h3 className="text-lg font-semibold text-foreground mb-1">
                  {item.name}
                </h3>
                <div className="flex flex-col font-semibold sm:flex-row sm:justify-between gap-2 text-sm text-muted-foreground">
                  <span>📞 Утас: {item.phone}</span>
                  <span>
                    📍 Байршил:{" "}
                    {item.location === "Монголд"
                      ? item.branchName
                      : item.location}
                  </span>
                  <span>💰 Үнэ: {item.price}₮</span>
                </div>
              </div>
            ))}
            <br />

            <div className="mt-4 p-4 rounded-lg bg-gray-50 text-center font-semibold text-base text-foreground shadow-sm">
              {(() => {
                const totalPrice = data.reduce(
                  (sum, i) => sum + Number(i.price || 0),
                  0
                );

                // Хөнгөлөлтийн логик
                // let discountRate = 0;
                // if (totalPrice >= 100_000 && totalPrice < 500_000) {
                //   discountRate = 0.05; // 5%
                // } else if (totalPrice >= 500_000) {
                //   discountRate = 0.1; // 10%
                // }

                let discountRate = 0;
                if (totalPrice >= 100_000) {
                  discountRate = 0.05;
                }

                const discount = totalPrice * discountRate;
                const payable = totalPrice - discount;

                const formatMoney = (n) =>
                  n.toLocaleString("en-US", { maximumFractionDigits: 0 });

                return totalPrice >= 100_000 ? (
                  <>
                    🧾 Нийт үнэ: {formatMoney(totalPrice)}₮ <br />
                    💸 Хөнгөлөлт {discountRate * 100}%: {formatMoney(discount)}₮{" "}
                    <br />→ Эцсийн төлбөр: {formatMoney(payable)}₮
                  </>
                ) : (
                  <span>🧾 Нийт үнэ: {formatMoney(totalPrice)}₮</span>
                );
              })()}
            </div>
          </div>
        )}

        {check === 1 && data.length === 0 && (
          <div className="mt-4 text-sm text-muted-foreground">
            Илгээмж олдсонгүй.
          </div>
        )}
      </div>
    </div>
  );
}
